import { makeStyles } from '@material-ui/core/styles';
import { ColorNames } from '@/utils/constants';

const useUnauthorizedMessageStyles = makeStyles(
  ({ spacing }) => ({
    layout: {
      flexDirection: 'row',
    },
    layoutMobile: {
      flexDirection: 'column',
      padding: spacing(2),
    },
    root: {
      display: 'flex',
    },
    layoutHeader: {
      marginTop: spacing(3),
      marginBottom: spacing(5),
    },
    messageWrapper: {
      color: ColorNames.white,
    },
    alert: {
      paddingTop: spacing(1),
      paddingBottom: spacing(1),
    },
  }),
  { name: 'UnauthorizedMessage' },
);

export default useUnauthorizedMessageStyles;
